module.exports = __webpack_public_path__ + "2a4f4b0a3646be9d8560178ebc4306e5.woff2";